import { CircularProgress } from "@mui/material";
import { useState } from "react";
import { Form, Modal } from "react-bootstrap";
import PhoneInput from "react-phone-number-input";
import { validateEmail } from "../../../service/commanFunction";
import { CustomSnackbar, useSnackState } from "../../../utils/useSnackState";

export function Phone1({ handleClose, nextPopup }) {
  const [snackProps, open] = useSnackState();
  const [form, setform] = useState({
    email: "",
    phone: "",
    code: "",
  });

  const error = {};
  const [showVerification, setshowVerification] = useState(false);
  const [isLoading, setisLoading] = useState(false);

  const handleSendVerificationCode = async () => {
    if (
      form.email.trim().length === 0 ||
      form.phone.trim().length === 0 ||
      !(await validateEmail(form.email))
    ) {
      open("Invalid input", "error");
      return;
    }
    setshowVerification(true);
  };
  const handleConfirm = async () => {
    if (form.code.trim().length === 0) {
      open("Enter verification code", "error");
      return;
    }
    nextPopup();
  };
  return (
    <Modal
      className="loginmodal"
      // {...props}
      show={true}
      onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <CustomSnackbar {...snackProps} />
      <div className="login-modal-mainbx">
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h4>Account recovery</h4>
            <p>Please, confirm your accout by phone</p>
          </Modal.Title>
          <button type="button" onClick={handleClose} className="close">
            <span aria-hidden="true">×</span>
            <span className="sr-only">Close</span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="login-modl-form">
            <div className="loginform-bx">
              <Form.Group className="subsform-fild">
                <Form.Label>Your email is</Form.Label>
                <Form.Control
                  disabled={showVerification}
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={(e) => setform({ ...form, email: e.target.value })}
                />
                {error.email && <span className="error">{error.email}</span>}
              </Form.Group>
              <Form.Group className="subsform-fild">
                <Form.Label>My mobile phone is</Form.Label>
                <PhoneInput
                  disabled={showVerification}
                  international
                  defaultCountry="IN"
                  placeholder="+375 22 123 45 67"
                  value={form.phone}
                  onChange={(e) => {
                    setform({ ...form, phone: e });
                  }}
                  className={error.phoneNumber ? "error-box" : ""}
                />
              </Form.Group>
              {showVerification && (
                <Form.Group className="subsform-fild">
                  <Form.Label>Verification code</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Enter here"
                    value={form.code}
                    onChange={(e) => setform({ ...form, code: e.target.value })}
                  />
                  {error.code && <span className="error">{error.email}</span>}
                </Form.Group>
              )}
              <div className="btnlogin-main">
                <button
                  style={{ fontSize: "0.8rem" }}
                  disabled={isLoading}
                  onClick={() => {
                    if (showVerification) handleConfirm();
                    else handleSendVerificationCode();
                  }}
                  className="btnlogin btnweak-bx"
                >
                  {isLoading ? (
                    <CircularProgress
                      size={"1.5rem"}
                      sx={{ color: "var(--purple)" }}
                    />
                  ) : showVerification ? (
                    "Confirm"
                  ) : (
                    "Send a verification code"
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </div>
    </Modal>
  );
}
